import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { ProfileService, Group, ConfigurationsService, StoreService, LocalesService, QuestionBase } from 'core/index';
import { Widget } from 'app/widget/widget';
import { GroupDashboardWidgetsService } from 'app/groups/services/group-dashboard-widgets.service';
import { ActivatedRoute } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { GroupDashboardService } from '../../services/group-dashboard.service';

@Component({
  selector: 'lms-group-dashboard',
  templateUrl: './group-dashboard.component.html',
  styleUrls: ['./group-dashboard.component.scss']
})
export class GroupDashboardComponent implements OnInit, OnDestroy {
  public group: Group;
  public role: any;
  public widgets: Widget[];
  public question: QuestionBase<any>;
  private groupDashboardSubscription: Subscription = new Subscription();
  public metadata: any;

  constructor(
    public profileService: ProfileService,
    public widgetsService: GroupDashboardWidgetsService,
    public route: ActivatedRoute,
    private configurationsService: ConfigurationsService,
    private localesService: LocalesService,
    private dashboardService: GroupDashboardService
  ) {}

  public ngOnInit(): void {
    this.dashboardService.getMetadata().subscribe((metadata) => (this.metadata = metadata));
    this.groupDashboardSubscription = this.getTooltipMessage$()
      .pipe(
        switchMap(() => this.getRoute$()),
        switchMap(() => this.getLoggedUserRole$())
      )
      .subscribe(() => {
        this.setDashboardWidgets();
      });
  }

  public ngOnDestroy(): void {
    this.groupDashboardSubscription.unsubscribe();
  }

  /**
   * Get the data of the activated route
   * @private
   */
  private getRoute$(): Observable<any> {
    return this.route.data.pipe(
      tap((data) => {
        this.group = data.group;
      })
    );
  }

  /**
   * Get the role of the logged user
   * @private
   */
  private getLoggedUserRole$(): Observable<any> {
    return this.profileService.getLoggedUserRole$().pipe(
      tap((role) => {
        this.role = role;
      })
    );
  }

  /**
   * Get the messages of group from configurations (contentful)
   * @private
   */
  private getTooltipMessage$(): Observable<any> {
    return this.configurationsService
      .getInfoMessage$(
        'toolTip',
        'fields.keys[match]',
        'groups.dashboard',
        'textoDeAyuda',
        this.localesService.getBrowserLocale()
      )
      .pipe(
        tap((tooltipsMap) => {
          StoreService.create('groups.dashboard', tooltipsMap);
        })
      );
  }

  private setDashboardWidgets(): void {
    if (this.group && this.role) {
      this.widgets = this.widgetsService.getWidgets(this.group, this.role);
    }
  }
}
